// Auto-generated - do not edit
import tokens from './tokens.json';
import type { ThemeTokens, Theme } from './types';

/**
 * Complete token object for all themes
 */
export const designTokens: ThemeTokens = tokens as unknown as ThemeTokens;

/**
 * Available theme names
 */
export const themes: Theme[] = ['light', 'dark', 'cupcake', 'business', 'grove-light', 'grove-dark'];

/**
 * Default theme
 */
export const defaultTheme: Theme = 'light';

/**
 * Light theme tokens
 */
export const lightTokens = designTokens.light;

/**
 * Dark theme tokens
 */
export const darkTokens = designTokens.dark;

/**
 * Cupcake theme tokens
 */
export const cupcakeTokens = designTokens.cupcake;

/**
 * Business theme tokens
 */
export const businessTokens = designTokens.business;

/**
 * Get tokens for a specific theme
 * @param theme - Theme name
 * @returns Token object for the specified theme
 */
export const getThemeTokens = (theme: Theme) => {
  return designTokens[theme];
};

/**
 * Check if a theme exists
 * @param theme - Theme name to check
 * @returns Whether the theme is valid
 */
export const isValidTheme = (theme: string): theme is Theme => {
  return themes.includes(theme as Theme);
};
